import * as React from 'react';
import Panel from '../../../../theme/components/Panel';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import {arrayMove} from 'react-sortable-hoc';
import {Button, ButtonToolbar} from 'reactstrap';
import {SortableList} from '../../../common/sortable-hoc/sortable-list';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import Modal from '../../../../theme/components/Modal';
import {error, success} from '../../../../utils/notification-actions';
import {connect} from 'react-redux';

interface PrioritariosConfContentState {
    lineasEdit: string[];
    totalEdit: string;
    inputsDehabilitados: boolean;
}

interface PrioritariosConfContentProps {
    totalLineas: number;
    lineas: mirana.IPrioritarioLinea[];
    fuerzaVentaId?: string;
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

class PrioritariosConfContent extends React.PureComponent<PrioritariosConfContentProps & ReduxProps, PrioritariosConfContentState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);
        this.state = {
            lineasEdit: [],
            totalEdit: '',
            inputsDehabilitados: true
        };
        this.handleGuardar = this.handleGuardar.bind(this);
    };

    private onTotalChange = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({totalEdit: e.target.value})
        }
    };

    public componentWillReceiveProps(props) {
        const lineas = props.lineas ? props.lineas.map((linea) => {
            return linea.prioridad;
        }) : [];
        this.setState({
            totalEdit: props.totalLineas ? props.totalLineas.toString() : '',
            lineasEdit: lineas,
            inputsDehabilitados: lineas.length <= 0
        });
    }

    private onSortEnd = ({oldIndex, newIndex}) => {
        this.setState({
            lineasEdit: arrayMove(this.state.lineasEdit, oldIndex, newIndex),
        });
    };

    private handleCancelar = () => {
        this.setState({lineasEdit: [], totalEdit: '', inputsDehabilitados: true});
    };

    public async handleGuardar() {
        try {
            const {fuerzaVentaId} = this.props;
            const {lineasEdit, totalEdit} = this.state;
            const formRequest = mirana.PrioritarioLineaList.create({
                totalLineas: totalEdit ? Number(totalEdit) : 0,
                lineas: Array.from(lineasEdit, linea => mirana.PrioritarioLinea.create({prioridad: linea})),
            });
            if (!fuerzaVentaId) {
                this.props.dispatch(error('Error', 'Fuerza de Venta no especificada'));
            } else {
                await this.apiClient.actualizarPrioritariosLineas(fuerzaVentaId, formRequest);
                this.props.dispatch(success('Notificación', 'Orden de prioridades actualizado correctamente'));
                this.handleCancelar();
            }
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error al guardar nuevo orden'));
        }
    }

    public render() {
        return (
            <Panel xs={12} md={9} xl={5} divider={true} title='Configuración'>
                <span>Mostrar </span><input type='text' className='prioritarios-total-input'
                                            value={this.state.totalEdit}
                                            disabled={this.state.inputsDehabilitados}
                                            onChange={this.onTotalChange}/><span> líneas en el reporte</span>
                <SortableList className='prioritarios-list' items={this.state.lineasEdit} onSortEnd={this.onSortEnd}/>
                <ButtonToolbar className='prioritarios-buttons form__button-toolbar'>
                    <Button disabled={this.state.inputsDehabilitados} type='button'
                            onClick={this.handleCancelar}>CANCELAR</Button>
                    <Modal color='primary' title='Confirmación' handleOk={this.handleGuardar}
                           message='¿Está seguro que desea guardar el nuevo orden?'>
                        <Button disabled={this.state.inputsDehabilitados} color='primary'>GUARDAR</Button>
                    </Modal>
                </ButtonToolbar>
            </Panel>
        );
    }
}

export default connect(mapStateToProps)(PrioritariosConfContent);



// WEBPACK FOOTER //
// ./src/components/pages/prioritarios/configuracion/prioritarios-conf-content.tsx